export enum EScanpoolState {
  CREATED = 'CREATED', ASSIGNED = 'ASSIGNED', UNASSIGNED = 'UNASSIGNED', VIRUS = 'VIRUS'
}
